import analyticsService from "@/services/analytics/analytics-service"
// @ts-ignore
import store from "@/store"

async function handleLogInEvent() {
  try {
    await store.dispatch("tasks/getUnassignedCareTeamTasksCount")
    await store.dispatch("tasks/getAssignedTasksCount")
    await store.dispatch("tasks/checkShowTasksBadgeIn")
  } catch (e) {
    console.error(`Global module failed to handle login event - upstream exception: ${e}`)
  }
  analyticsService.loggedIn(store.getters["me/user"])
}
async function handleLogOutEvent() {
  analyticsService.loggedOut()
}

function handleUnauthenticatedApiResponse() {
  if (store.getters["me/isLoggedIn"]) {
    store.dispatch("me/logout")
  }
}

export default {
  handleUnauthenticatedApiResponse,
  handleLogInEvent,
  handleLogOutEvent
}
